/**
 * Mixed-household upsell (client 2026-08-27): when everyone has submitted and
 * the ONLY thing left is that some members hold pre-screening rather than
 * full, the combined report can't be produced — so instead of explaining the
 * blockage, offer the fix. "Get Report" upgrades every pre-screening member;
 * the combined report then generates automatically once their reports land.
 *
 * Rendered INSIDE the header's report slot, in place of the "Combined Report
 * Unavailable" state (never alongside it): while anyone is still to submit,
 * the wait is the story and this offer would be a false promise. Same visual
 * language as the individual page's UpsellBanner — crown in a pale amber
 * disc, dark pill CTA.
 */
import { ArrowRight, Crown } from 'lucide-react'

export function CombinedUpsellBody({
	onGetReport,
}: {
	/** Opens the upgrade confirm; absent when the viewer may not initiate a
	 * full screen (the CTA is then withheld rather than failing on click). */
	onGetReport?: () => void
}) {
	return (
		// Crown + copy on the left, CTA on the RIGHT — the individual page's
		// UpsellBanner shape (client 2026-08-27), wrapping on narrow screens.
		<div className="flex flex-wrap items-center justify-center gap-4">
			<span className="flex size-14 shrink-0 items-center justify-center rounded-full bg-[#FFF6EA] text-[#F59F0A]">
				<Crown className="size-6" />
			</span>
			<p className="min-w-0 flex-1 basis-44 text-left text-[15px] leading-snug text-gray-500 capitalize">
				Run A Full Screen On Everyone &amp; Unlock The Combined Report
			</p>
			{onGetReport ? (
				<button
					type="button"
					onClick={onGetReport}
					className="flex shrink-0 cursor-pointer items-center gap-2 rounded-full bg-[#32302F] px-6 py-3 text-[15px] font-bold text-white transition-colors hover:bg-[#1a1918]"
				>
					Get Report
					<ArrowRight className="size-4" />
				</button>
			) : null}
		</div>
	)
}
